export function Logo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <img src="/logo-and-footer.png" alt="PcodeX Logo" style={{ height: '28px', width: 'auto' }} />
      <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
        PcodeX
      </span>
    </div>
  );
}
